<template>
  <div class="rich-text-editor">
    <quill-editor
      v-model="localContent"
      :options="editorOptions"
      class="quill-editor"
      @ready="onEditorReady"
    ></quill-editor>
  </div>
</template>

<script>
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import qiniuUploader from '@/util/qiniuUploader'
import { getQiniuToken } from '@/api/public'

export default {
  name: 'RichTextEditor',
  components: {
    quillEditor
  },
  created() {
    // Quill 1.x 原生支持表格，无需额外注册
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    },
    path: {
      type: String,
      default: 'images'
    }
  },
  data() {
    return {
      postData: {
          token: "",
          key: this.path
      },
      domain: "https://cdn.puditech.com",
      actionPath: "https://up-z0.qiniup.com",
      localContent: this.value,
      editorOptions: {
        theme: 'snow',
        placeholder: this.placeholder,
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['image'],
            ['clean']
          ],
          clipboard: {
            matchVisual: false
          }
        }
      }
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue !== this.localContent) {
          this.localContent = newValue
        }
      },
      immediate: true
    },
    localContent: {
      handler(newValue) {
        this.$emit('input', newValue)
        this.$emit('change', newValue)
      }
    }
  },
  methods: {
    onEditorReady(quill) {
      // 为图片按钮添加点击事件处理
      const toolbar = quill.getModule('toolbar')
      toolbar.addHandler('image', () => {
        // 创建一个隐藏的文件输入框
        const input = document.createElement('input')
        input.setAttribute('type', 'file')
        input.setAttribute('accept', 'image/*')
        input.onchange = () => {
          const file = input.files[0]
          if (file) {
            // 获取七牛云上传令牌
            getQiniuToken().then((res) => {
              // 初始化七牛云上传配置
              qiniuUploader.init({
                region: "CXC",
                uptoken: res.data,
                domain: this.domain,
                shouldUseQiniuFileName: true,
                key: this.path + "/"
              })

              // 上传图片到七牛云
              qiniuUploader.upload(
                URL.createObjectURL(file),
                (res) => {
                  // 上传成功，插入图片到编辑器
                  const range = quill.getSelection()
                  quill.insertEmbed(range.index, 'image', res.imageURL)
                },
                (error) => {
                  console.error('上传图片失败:', error)
                },
                {
                  file: file // 传递原始文件对象，用于获取文件扩展名
                }
              )
            })
          }
        }
        input.click()
      })


    }
  },
  mounted() {
    let editHeight = document.getElementsByClassName('quill-editor')[0].clientHeight
    let toolHeight = document.getElementsByClassName('ql-toolbar')[0].clientHeight
    document.getElementsByClassName('ql-container')[0].style.height = (editHeight - toolHeight) + 'px'
    // 初始化七牛云上传配置
    getQiniuToken().then((res) => {
        this.postData.token = res.data;
        qiniuUploader.init({
            region: "CXC",
            uptoken: "",
            domain: 'pd-zd',
            shouldUseQiniuFileName: true,
            key: this.path + "/"
        });
    });
  }
}
</script>

<style lang="scss">
.rich-text-editor {
  width: 100%;
  height: 100%;
}

.quill-editor {
  height: 100%;
  margin-bottom: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.ql-container {
  height: calc(100% - 20px);
}

.ql-editor {
  height: 100%;
  min-height: 250px;
}

/* 表格样式 */
.ql-editor table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}

.ql-editor table td {
  border: 1px solid #ccc;
  padding: 8px;
  min-width: 50px;
}

.ql-editor table td.selected {
  background-color: #e6f7ff;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .quill-editor {
    height: 200px;
  }

  .ql-toolbar.ql-snow {
    flex-wrap: wrap;
  }

  .ql-toolbar.ql-snow .ql-formats {
    margin-right: 10px;
    margin-bottom: 5px;
  }
}
</style>